const customBuyNowSelector = '.custom-buy-now-btn';

function findProductForm(button) {
  const scopes = [
    button.closest('.product-details'),
    button.closest('.product-information'),
    document,
  ];

  for (const scope of scopes) {
    if (!scope) continue;

    const form = scope.querySelector(
      'form[data-type="add-to-cart-form"], form[action*="/cart/add"]'
    );

    if (form) return form;
  }

  return null;
}

function isProductAvailable(form) {
  if (!form) return false;

  const variantInput = form.querySelector('[name="id"]');
  const addButton = form.querySelector(
    'button[name="add"], .add-to-cart-button, button[type="submit"]'
  );

  return Boolean(variantInput?.value && (!addButton || !addButton.disabled));
}

function syncCustomBuyNowButton(button) {
  if (button.dataset.processing === 'true') return;

  const form = findProductForm(button);
  const available = isProductAvailable(form);

  button.disabled = !available;
  button.textContent = available ? 'Buy it now' : 'Sold out';
}

function syncCustomBuyNowButtons(scope = document) {
  scope.querySelectorAll(customBuyNowSelector).forEach(syncCustomBuyNowButton);
}

function scheduleCustomBuyNowSync(scope = document) {
  window.requestAnimationFrame(() => {
    window.setTimeout(() => syncCustomBuyNowButtons(scope), 0);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => scheduleCustomBuyNowSync());
} else {
  scheduleCustomBuyNowSync();
}

document.addEventListener('change', (event) => {
  if (event.target.closest('.product-information, .product-details')) {
    scheduleCustomBuyNowSync();
  }
});

document.addEventListener('shopify:section:load', (event) => {
  scheduleCustomBuyNowSync(event.target);
});

document.addEventListener('shopify:block:select', (event) => {
  scheduleCustomBuyNowSync(event.target.closest('.shopify-section') || document);
});

document.addEventListener(
  'click',
  async (event) => {
    const button = event.target.closest(customBuyNowSelector);
    if (!button) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (window.Shopify?.designMode) {
      button.dataset.processing = 'false';
      syncCustomBuyNowButton(button);
      return;
    }

    const form = findProductForm(button);
    if (!isProductAvailable(form)) {
      syncCustomBuyNowButton(button);
      return;
    }

    button.dataset.processing = 'true';
    button.disabled = true;
    button.textContent = 'Processing...';

    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 12000);

    try {
      const root = window.Shopify?.routes?.root || '/';
      const formData = new FormData(form);
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json',
        },
        signal: controller.signal,
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(
          errorData.description || errorData.message || 'Unable to add product.'
        );
      }

      window.location.assign(`${root}checkout`);
    } catch (error) {
      console.error('Buy it now error:', error);
      window.alert('Unable to continue to checkout. Please try again.');
      button.dataset.processing = 'false';
      syncCustomBuyNowButton(button);
    } finally {
      window.clearTimeout(timeout);
    }
  },
  true
);
